export default {"src":"/_next/static/media/linkedIn.0ccc3ab3.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};